let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = Promise.all([load("5EQhG"), load("Wowvf"), load("hhss7"), load("kG8pF")]).then(() => parcelRequire('9bXIX'));